<script setup lang="ts">
const { data, error, status } = useLazySanityQuery<GetStartedResponse>(getGetStarted)

const { setSectionsData, refresh } = useActiveSection()

watch(
  status,
  () => {
    if (status.value === 'error' || (status.value === 'success' && !data.value)) {
      throw createError({
        statusCode: 404,
        stack: error.value?.stack,
        statusMessage: error.value?.message || 'Page Not Found',
        fatal: true,
      })
    }
  },
  { immediate: true },
)

useSanitySeo(() => data.value?.seo)

watch(
  data,
  async () => {
    if (!data.value || import.meta.server) return

    setSectionsData(data.value.pageSections)
    setTimeout(refresh)
  },
  { immediate: true },
)

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet

  return isMobileOrTablet || innerWidth.value < 1024
})

const $page = useTemplateRef('$page')

const { frontPages } = useGlobalState()
</script>

<template>
  <div class="bg-black">
    <Transition name="fade-page">
      <div v-if="data" ref="$page" class="page-to-pin">
        <div
          ref="$content"
          class="page-sections-wrapper min-h-screen"
          :style="{
            '--page-cta-bg': 'var(--color-neon-yellow)',
            '--page-cta-text': 'var(--color-black)',
          }"
        >
          <PageSections v-if="data?.pageSections" :sections="data.pageSections" />
          <SiteFooter />
        </div>

        <InfiniteNavigation
          v-if="!isMobile"
          :parent="$page"
          :href="frontPages.index.slug"
          :label="frontPages.index.name"
        />
      </div>

      <!-- loading indicator -->
      <div
        v-else
        class="fixed top-0 left-0 flex h-screen w-full items-center justify-center bg-black"
      >
        <!-- <IconsLogomark class="text-neon-yellow size-10" /> -->
      </div>
    </Transition>

    <ClientOnly>
      <Teleport to="#teleports">
        <NuxtPage :transition="overlayTransitions" />
      </Teleport>
    </ClientOnly>
  </div>
</template>
